// main
import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";

import WebbDividerMedium from "../webx/webb-divider-md"
import WebbDividerSmall from "../webx/webb-divider-sm";
import WebbSpinner from "../webx/webb-spinner";

import TokenCardMedium from "../webx/token-card-md";

import { GetUserForm } from "../../services/srvc-utilities";
import { GetLocalUser, GetLocalBusiness } from "../../services/srvc-auth-user";

import { UsersMedia } from "../../services/srvc-store-realm";

import { Row, Col, Space, Button, Image, Form, Input } from 'antd';

export default function UsersArtworksModule () {
  
  const usxx = GetUserForm();
  const asset = GetUserForm() === "in" ? GetLocalUser() : GetLocalBusiness();
  
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  
  const [data, setData] = useState();
    
  useEffect( async () => {
    if (asset){
      const fetchData = async() => {
        
        setLoading(true);

        const media = await UsersMedia({
          data: {user: asset.usid},
          user: asset.usid
        })
        console.log(media)
        setData(media.data.media)
        setLoading(false);
      }
      fetchData()
    } else {}
  },[]);

  if (loading) return <WebbSpinner/>
  if (data.length===0) return <p className="text-center text-color-tone">No Artwork</p>

  return (
  <>
    <div className="d-none">
      <Row justify="space-between">
        <Col span={21}>
          <Row justify="start" align="middle">
            <Col flex="auto" className="">
              <h3 className='m-0'>Media Store</h3>
              <h4 className='m-0 text-color-tone'>Total: {data.length}</h4>
            </Col>
          </Row>
        </Col>

        <Col span={3} className="py-1 text-end" >
          <Space direction="horizontal" 
            style={{width: '100%', justifyContent: 'right'}}>
            <Row justify="center" align="middle"
            className={`text-center back-color-lite hirich cursor`}
            style={{width:'3.3rem', height:'3.3rem', borderRadius:'50%'}}
            onClick={() => history.push(`/${usxx}/media/create`)}
            ><i className={`bx bx-plus`}></i>
          </Row>
          </Space>
        
        </Col>
      </Row>
    </div>


    {/* media */}
    <WebbDividerMedium />
    <div className='m-0 p-0'>
      <Row className="" gutter={{ xs: 12, sm: 12, md: 12, lg: 24 }}>

      {data && data.map((item, i) => (
        <Col className="m-0 p-0 mb-x" xs={{span:8}} md={{span:8}} key={i}>
          <Link to={`/${usxx}/mx/v/${item.media}`}>
            {/* {item.name} */}
            {/* <img src={item.link}></img> */}
            <TokenCardMedium data={item}/>
          </Link>
          
        </Col>
      ))}
      </Row>
    </div>

  </>
  )
}